/**
 * Shared English + Urdu option pairs for static admin dropdowns.
 * English `value` is stored in the existing column; Urdu `value` is stored in `*_ur`.
 */

export const DEALERSHIP_OPTIONS = [
  { en: "authorizedDealer", enLabel: "Authorized Dealer", ur: "مجاز ڈیلر" },
  { en: "manufacturer", enLabel: "Manufacturer", ur: "مینوفیکچرر" },
];

export const ASSOCIATED_HOUSE_OPTIONS = [
  { en: "3 Marla", ur: "۳ مرلہ" },
  { en: "5 Marla", ur: "۵ مرلہ" },
  { en: "8 Marla", ur: "۸ مرلہ" },
  { en: "10 Marla", ur: "۱۰ مرلہ" },
  { en: "1 kanal", ur: "۱ کنال" },
  { en: "2 kanal", ur: "۲ کنال" },
  { en: "others", ur: "دیگر" },
];

export const STANDARD_PLAN_BAND_OPTIONS = [
  { en: "Up To 5 Marla", ur: "۵ مرلہ تک" },
  { en: "From 5 to 8 Marla", ur: "۵ سے ۸ مرلہ" },
  { en: "From 8 to 12 Marla", ur: "۸ سے ۱۲ مرلہ" },
  { en: "From 12 to 18 Marla", ur: "۱۲ سے ۱۸ مرلہ" },
  { en: "From 18 to 25 Marla", ur: "۱۸ سے ۲۵ مرلہ" },
  { en: "Above 25 Marla", ur: "۲۵ مرلہ سے زیادہ" },
];

export const ASSOCIATED_ELEVATION_OPTIONS = [
  { en: "10 to 20 Feet", ur: "۱۰ سے ۲۰ فٹ" },
  { en: "21 to 30 Feet", ur: "۲۱ سے ۳۰ فٹ" },
  { en: "31 to 40 Feet", ur: "۳۱ سے ۴۰ فٹ" },
  { en: "41 to 50 Feet", ur: "۴۱ سے ۵۰ فٹ" },
  { en: "51 to 65 Feet", ur: "۵۱ سے ۶۵ فٹ" },
  { en: "66 to 80 Feet", ur: "۶۶ سے ۸۰ فٹ" },
  { en: "others", ur: "دیگر" },
];

export const BLOG_STATUS_OPTIONS = [
  { en: "draft", enLabel: "Draft", ur: "مسودہ" },
  { en: "published", enLabel: "Published", ur: "شائع شدہ" },
  { en: "archived", enLabel: "Archived", ur: "محفوظ شدہ" },
];

export const DESIGN_TYPE_OPTIONS = [
  { en: "Modern", ur: "جدید" },
  { en: "Traditional", ur: "روایتی" },
  { en: "Contemporary", ur: "معاصر" },
  { en: "Minimalist", ur: "منیملسٹ" },
  { en: "Luxury", ur: "لگژری" },
  { en: "Industrial", ur: "انڈسٹریل" },
  { en: "Classical", ur: "کلاسیکل" },
  { en: "Others", ur: "دیگر" },
];

export const UNIT_OPTIONS = [
  { en: "per_can", enLabel: "Per Can", ur: "فی کین" },
  { en: "per_piece", enLabel: "Per Piece", ur: "فی پیس" },
  { en: "per_bag", enLabel: "Per Bag", ur: "فی بیگ" },
  { en: "per_roll", enLabel: "Per Roll", ur: "فی رول" },
  { en: "per_bottle", enLabel: "Per Bottle", ur: "فی بوتل" },
  { en: "per_running_feet", enLabel: "Per Running Feet", ur: "رننگ فٹ" },
  { en: "per_drum", enLabel: "Per Drum", ur: "فی ڈرم" },
  { en: "per_quarter", enLabel: "Per Quarter", ur: "فی کوارٹر" },
  { en: "per_square_feet", enLabel: "Per Square Feet", ur: "فی مربع فٹ" },
  { en: "per_cubic_feet", enLabel: "Per Cubic Feet", ur: "فی مکعب فٹ" },
  { en: "per_kit", enLabel: "Per Kit", ur: "فی کٹ" },
  { en: "per_sheet", enLabel: "Per Sheet", ur: "فی شیٹ" },
  { en: "per_pair", enLabel: "Per Pair", ur: "فی جوڑا" },
  { en: "per_set", enLabel: "Per Set", ur: "فی سیٹ" },
];

/** Map English value -> Urdu value for a given options list */
export const urduFor = (options, enValue) =>
  options.find((o) => o.en === enValue)?.ur || "";

/** Map Urdu value -> English value */
export const englishFor = (options, urValue) =>
  options.find((o) => o.ur === urValue)?.en || "";
